// extracted by mini-css-extract-plugin
export default {"jurisdictionPopup__buttonWrapper":"jurisdictionPopup__buttonWrapper--UErUgE0N","jurisdictionPopup__accent":"jurisdictionPopup__accent--Xzwv4LwZ"};